// URL base que cambia entre desarrollo y producción
//const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8081/api';

// const API_BASE_URL =  'http://localhost:8081/api';

// // Cliente HTTP con autenticación
// export const apiClient = {
//   async get(url: string, token?: string) {
//     const headers: HeadersInit = {
//       'Content-Type': 'application/json',
//     };

//     if (token) {
//       headers['Authorization'] = `Bearer ${token}`;
//     }

//     const fullUrl = `${API_BASE_URL}${url}`;

//     console.log(`📡 GET Request to: ${fullUrl}`);

//     const response = await fetch(fullUrl, {
//       method: 'GET',
//       headers,
//       credentials: 'include',
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       console.error(`❌ API Error ${response.status}:`, errorText);
//       throw new Error(errorText || 'Request failed');
//     }

//     return response.json();
//   },

//   async post(url: string, data: any, token?: string) {
//     const headers: HeadersInit = {
//       'Content-Type': 'application/json',
//     };

//     if (token) {
//       headers['Authorization'] = `Bearer ${token}`;
//     }

//     const fullUrl = `${API_BASE_URL}${url}`;

//     console.log(`📡 POST Request to: ${fullUrl}`, data);

//     const response = await fetch(fullUrl, {
//       method: 'POST',
//       headers,
//       body: JSON.stringify(data),
//       credentials: 'include',
//     });

//     console.log(`📡 POST Response status: ${response.status} for ${url}`);

//     if (!response.ok) {
//       try {
//         const errorData = await response.json();
//         throw new Error(errorData.message || `Request failed with status ${response.status}`);
//       } catch (jsonError) {
//         const errorText = await response.text();
//         throw new Error(errorText || `Request failed with status ${response.status}`);
//       }
//     }

//     // Manejar diferentes códigos de estado
//     if (response.status === 200 || response.status === 201) {
//       try {
//         return await response.json();
//       } catch (error) {
//         return { success: true, message: 'Operation completed successfully' };
//       }
//     }

//     return response.json();
//   },
// URL base que cambia entre desarrollo y producción
const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Cliente HTTP con autenticación
export const apiClient = {
  async get(url: string, token?: string) {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const fullUrl = `${API_BASE_URL}${url}`;

    console.log(`📡 GET Request to: ${fullUrl}`);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 segundos para producción

    try {
      const response = await fetch(fullUrl, {
        method: 'GET',
        headers,
        credentials: 'include',
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`❌ API Error ${response.status}:`, errorText);
        throw new Error(errorText || `Request failed with status ${response.status}`);
      }

      return response.json();
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        console.error('❌ Request timeout after 15 seconds');
        throw new Error('Request timeout - Server is not responding');
      }
      throw error;
    }
  },

  async post(url: string, data: any, token?: string) {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const fullUrl = `${API_BASE_URL}${url}`;

    console.log(`📡 POST Request to: ${fullUrl}`, data);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {
      const response = await fetch(fullUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
        credentials: 'include',
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      console.log(`📡 POST Response status: ${response.status} for ${url}`);

      if (!response.ok) {
        try {
          const errorData = await response.json();
          throw new Error(errorData.message || `Request failed with status ${response.status}`);
        } catch (jsonError) {
          const errorText = await response.text();
          throw new Error(errorText || `Request failed with status ${response.status}`);
        }
      }

      // Para respuestas vacías (como DELETE exitoso)
      if (response.status === 200 || response.status === 201) {
        try {
          return await response.json();
        } catch (error) {
          // Si no hay JSON, retornar éxito
          return { success: true, message: 'Operation completed successfully' };
        }
      }

      return response.json();
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        console.error('❌ Request timeout after 15 seconds');
        throw new Error('Request timeout - Server is not responding');
      }
      throw error;
    }
  },

  async put(url: string, data: any, token?: string) {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const fullUrl = `${API_BASE_URL}${url}`;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {
      const response = await fetch(fullUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(data),
        credentials: 'include',
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Request failed with status ${response.status}`);
      }

      if (response.status === 200 || response.status === 204) {
        try {
          return await response.json();
        } catch (error) {
          return { success: true, message: 'Update completed successfully' };
        }
      }

      return response.json();
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        console.error('❌ Request timeout after 15 seconds');
        throw new Error('Request timeout - Server is not responding');
      }
      throw error;
    }
  },

  async delete(url: string, token?: string) {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const fullUrl = `${API_BASE_URL}${url}`;

    console.log(`📡 DELETE Request to: ${fullUrl}`);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {
      const response = await fetch(fullUrl, {
        method: 'DELETE',
        headers,
        credentials: 'include',
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      console.log(`📡 DELETE Response status: ${response.status} for ${url}`);

      if (!response.ok) {
        try {
          const errorData = await response.json();
          throw new Error(errorData.message || `Request failed with status ${response.status}`);
        } catch (jsonError) {
          const errorText = await response.text();
          throw new Error(errorText || `Request failed with status ${response.status}`);
        }
      }

      if (response.status === 200 || response.status === 204) {
        try {
          return await response.json();
        } catch (error) {
          return { success: true, message: 'Delete completed successfully' };
        }
      }

      return response.json();
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        console.error('❌ Request timeout after 15 seconds');
        throw new Error('Request timeout - Server is not responding');
      }
      throw error;
    }
  },

  // Método para upload de archivos
  async upload(url: string, formData: FormData, token?: string) {
    const headers: HeadersInit = {};

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const fullUrl = `${API_BASE_URL}${url}`;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 segundos para uploads

    try {
      const response = await fetch(fullUrl, {
        method: 'POST',
        headers,
        body: formData,
        credentials: 'include',
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Upload failed with status ${response.status}`);
      }

      return response.json();
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        console.error('❌ Upload timeout after 30 seconds');
        throw new Error('Upload timeout - Server is not responding');
      }
      throw error;
    }
  },
};

// Utilidad para debug
export const logApiConfig = () => {
  console.log('🔧 API Configuration:');
  console.log('   Base URL:', API_BASE_URL);
  console.log('   Environment:', import.meta.env.MODE);
  console.log('   VITE_API_URL:', import.meta.env.VITE_API_URL);
};

// Interceptor global para manejar errores de red
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);
    return response;
  } catch (error) {
    if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
      console.error('🌐 Network error - Check your internet connection');
      throw new Error('Network error - Please check your internet connection and try again');
    }
    throw error;
  }
};